'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { getTemporaryOverlayNodePositions } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    temporaryOverlays: getTemporaryOverlayNodePositions(state)
  };
};
class TemporaryOverlaysContainer extends Component {
  render() {
    const {
      temporaryOverlays
    } = this.props;
    return /*#__PURE__*/_jsx(CSSTransitionGroup, {
      transitionName: 'hs-temporary-overlay',
      transitionLeave: false,
      transitionEnterTimeout: 1000,
      children: temporaryOverlays.map(overlay => {
        const {
          id,
          top,
          left,
          height,
          width
        } = overlay;
        return /*#__PURE__*/_jsx("div", {
          "data-transition-wrapper": true,
          style: {
            position: 'absolute',
            pointerEvents: 'none',
            top,
            left,
            height,
            width
          }
        }, id);
      })
    });
  }
}
TemporaryOverlaysContainer.propTypes = {
  temporaryOverlays: PropTypes.array.isRequired
};
export default connect(mapStateToProps)(TemporaryOverlaysContainer);